export const loginInterstitialPage = () =>
  import("./LoginInterstitialPage").then((m) => ({ Component: m.LoginInterstitialPage }));
